<template>
  <div v-if="modalIsOpened" class="fixed inset-0 w-full bg-black/30 z-50" @click.self="closeModal">
    <div class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8">
      <div class="w-[100vw] max-w-[1000px] px-[20px] m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white  max-w-[1000px]">
          <div id="title"
            class="rounded-t-[10px] flex items-center justify-between py-[12px] pl-[20px] pr-[10px] bg-[#9B237B]">
            <span class="PC_Body2-R text-[#FCFCFC]">ประวัติ</span>
            <CloseIcon @click="closeModal"
              class="w-[24px] h-[24px] bg-white text-[#9B237B] rounded-full cursor-pointer" />
          </div>
          <div class="flex flex-col justify-center items-start gap-[10px] py-[12px] px-[20px]">
            <!-- filter -->
            <div class="w-full flex items-center gap-[10px] flex-wrap sm:flex-nowrap">
                            <div class="w-full sm:max-w-[257px]">
              <DatePicker v-model="filter.date" format="D MMM YYYY" placeholder="เลือกช่วงเวลาที่แก้ไข"
                @update:modelValue="(res) => changeDate(res)" range minDate="" />
                </div>
              <div class="w-full">
                <SearchBox :placeholder="'ค้นหา ชื่อผู้ถูกประเมิน หรือผู้ลงข้อมูล'" v-model="filter.search"
                  @update:modelValue="() => { (filter.page = ''), debouncedFetch(); }" />
              </div>
            </div>
            <!-- filter -->
            <div class="w-full flex flex-col gap-[20px]">
              <!-- table -->
              <div
                class="w-full p-[6px] flex flex-col bg-[#FFFFFF] text-left rounded-[6px] border-[1px] border-solid border-[#B7B2B5] overflow-auto">
                <table class="min-w-[850px]">
                  <thead>
                    <tr>
                   
                      <th
                        class="h-[53px] w-[152px] overflow-hidden  p-[10px] bg-[#9B237B] text-[#FFFFFF] text-left rounded-l-[4px] border-r-[1px] border-solid border-[#FFFFFF]">
                        <span class="PC_Body2-R"> ชื่อแบบประเมิน </span>
                      </th>
                      <th
                        class="h-[53px] w-[152px] overflow-hidden  p-[10px] bg-[#9B237B] text-[#FFFFFF] text-left rounded-l-[4px] border-r-[1px] border-solid border-[#FFFFFF]">
                        <span class="PC_Body2-R"> ชื่อผู้ถูกประเมิน </span>
                      </th>
                      <th
                        class="h-[53px] w-[152px] overflow-hidden  p-[10px] bg-[#9B237B] text-[#FFFFFF] text-left rounded-l-[4px] border-r-[1px] border-solid border-[#FFFFFF]">
                        <span class="PC_Body2-R"> ผู้ลงข้อมูล </span>
                      </th>
                      <th
                        class="h-[53px] w-[128px] overflow-hidden  p-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]">
                        <span class="PC_Body2-R"> วันที่ประเมิน </span>
                      </th>
                      <th
                        class="h-[53px] w-[128px] overflow-hidden  p-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]">
                                <p class="PC_Body2-R">วันที่ และเวลา</p>
                        <p class="PC_Body2-R">ที่สร้าง</p>
                      </th>
                      <th
                        class="h-[53px] w-[128px] overflow-hidden  p-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]">
                             <p class="PC_Body2-R">วันที่ และเวลา</p>
                        <p class="PC_Body2-R">ที่แก้ไขล่าสุด</p>
                      </th>

                   
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, rowIndex) in list" :key="rowIndex" :class="[
                      '!border-none',
                      { 'bg-[#FBEFF8]': (rowIndex + 1) % 2 === 0 },
                    ]">
                    
                      <td class="w-[152px] p-[10px] !border-none truncate ">
                        <span class="PC_Body2-R text-[#1F1D1F] ">
                          {{ row.name }}
                        </span>
                      </td>
                      <td class="w-[152px] p-[10px] !border-none">
                        <span class="PC_Body2-R text-[#1F1D1F]">
                          <!-- {{ formatDateTime(row.datetime, 'time') }}
                               {{ formatDateTime(row.datetime, 'date') }} -->
                          {{ row.name_of_assessment }}
                        </span>
                      </td>
                      <td class="w-[152px] p-[10px] !border-none">
                        <span class="PC_Body2-R text-[#1F1D1F]">
                          {{ row.created_by_name }}
                        </span>
                      </td>
                      <td class="w-[128px] p-[10px] !border-none">
                        <div class="flex items-center gap-[10px]">
                          <span class="PC_Body2-R text-[#1F1D1F]">
                            <!-- {{ formatDateTime(row.datetime, 'date') }} -->
                            {{ $formatDate5(row.datetime) }}
                          </span>
                        </div>
                      </td>
                      <td class="w-[128px] p-[10px] !border-none">
                        <div class="flex items-center gap-[10px]">
                          <span class="PC_Body2-R text-[#1F1D1F]">
                            <!-- {{ formatDateTime(row.created_at, 'full') }} -->
                            {{ $convertToBuddhistYear(row.created_at) }}

                          </span>
                        </div>
                      </td>
                      <td class="w-[128px] p-[10px] !border-none">
                        <div class="flex items-center gap-[10px]">
                          <span class="PC_Body2-R text-[#1F1D1F]">
                            <!-- {{ formatDateTime(row.updated_at, 'full') }} -->
                            {{ $convertToBuddhistYear(row.updated_at) }}
                          </span>
                        </div>
                      </td>

                      
                    </tr>
                    <NoInfoYetComponent v-if="list.length <= 0" :col="'6'" :icon="'MedicalKitIcon'" />

                  </tbody>
                </table>
              </div>
              <!-- table -->
              <!-- pagination -->
              <PaginationComponent :items="paginationInfo" @selectedPage="handlePage" />
              <!-- pagination -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive, watch } from "vue";
import axios from "axios";
import { useRoute, useRouter } from "vue-router";
import { formatDate } from "date-fns";
import moment from "moment";
import { debounce } from "lodash";

const route = useRoute();
const router = useRouter();

const formatDateTime = (date, type) => {
  const m = moment(date, 'YYYY-MM-DD HH:mm:ss')
  if (type == "date") {
    return m.format('YYYY-MM-DD') // 2025-08-28
  } else if (type == "time") {
    return m.format('HH:mm:ss')   // 00:00:00
  } else {
    return m.format('YYYY-MM-DD HH:mm')
  }
}

const items = {
  current_page: 1, // หน้าที่กำลังแสดงอยู่
  last_page: 99, // จำนวนหน้าทั้งหมด
  from_page: 1, // หน้าเริ่มต้นของชุดข้อมูลนี้
  to_page: 10, // หน้าสุดท้ายของชุดข้อมูลนี้
  per_page: 10, // จำนวนรายการต่อหน้า
  total: 990, // จำนวนรายการทั้งหมด
};
const filter = ref({
  search: '',
  paginate: 10,
  page: "",
  date: "",
  start_date: "",
  end_date: "",
  id: ""
});
const pagination = ref(null);
const modalIsOpened = ref(false);
const list = ref(false);
const paginationInfo = ref({});

onMounted(() => {
})
const openModal = (id) => {
  document.body.style.overflow = "hidden";
  document.body.style.position = "fixed";
  document.body.style.width = "100%";
  filter.value.id = id
  modalIsOpened.value = true;
  getData()
};
const getData = async () => {
  await axios.get("/assessment-logs/" + filter.value.id, { params: filter.value }).then((res) => {
    paginationInfo.value = res.data.data;
    list.value = res.data.data.data;
  })
    .catch((error) => {
      if (error) {
        console.log("error", error);
      }
    });
};
const debouncedFetch = debounce(getData, 300);

const changeDate = (res) => {
  if (res == null) {
    filter.value.date = ''
    filter.value.start_date = ''
    filter.value.end_date = ''
  } else {
    filter.value.date = res
    if (res.length == 2) {
      filter.value.start_date = res[0]
      filter.value.end_date = res[1]
    }
  }
  getData();
};

const closeModal = () => {
  filter.value.id = ''
  filter.value.search = ''
  filter.value.paginate = 10
  filter.value.page = ""
  filter.value.date = ""
  filter.value.start_date = ""
  filter.value.end_date = ""

  document.body.style.position = "";
  document.body.style.width = "";
  document.body.style.overflow = "auto";
  modalIsOpened.value = false;




};

const info = (assessment) => {
  console.log(route.params);

  const path = routeMap(assessment)[route.name];
  if (path) {
    document.body.style.position = "";
    document.body.style.width = "";
    document.body.style.overflow = "auto";
    router.push(path());

  }
};
const routeMap = (assessment) => ({
  "victim-detail-in-shelter": () => `/shelter/${route.meta.decodedParams?.shelterId}/victims/${route.meta.decodedParams?.victimId}/${userProfile.value.id}/${assessment.id}/form${assessment.type}`,
  "victims-detail": () => `/population/victims/${route.meta.decodedParams?.victimId}/${userProfile.value.id}/${assessment.id}/form${assessment.type}`,
  "post-disaster-period-detail": () => `/population/post-disaster-period/${route.meta.decodedParams?.victimId}/${userProfile.value.id}/${assessment.id}/form${assessment.type}`,
  "population-detail": () => `/population/total-population/${route.meta.decodedParams?.populationId}/${userProfile.value.id}/${assessment.id}/form${assessment.type}`,
});

const handlePage = (page, perpage) => {
  filter.value.page = page;
  filter.value.paginate = perpage;
  getData();
};

defineExpose({ openModal });
</script>

<style lang="scss" scoped>
@media screen and (max-width: 64rem) {
  .PC_Body1-R {
    font-size: 16px !important;
  }
}
</style>